module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Group-chat-0980fee61c9963dae2f4aa4bd4fec3c6.svg";